module.exports = __webpack_public_path__ + "static/media/qyj2_hg_3000_02.0c84dcce.png";